
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SubscriptionService } from 'src/core/services/subscription.service';

@Component({
  selector: 'app-subscribed-notifications',
  imports: [TranslocoModule],
  templateUrl: './subscribed-notifications.component.html',
  styleUrl: './subscribed-notifications.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SubscribedNotificationsComponent {

  constructor(private subscriptionService: SubscriptionService) { }

  @Input() mode: string = "notification";

  messages: Notification[] = [];
  messagesCenter: Notification[] = [];
  notificationOpen: boolean = false;
  selectedNotification: number = 1;

  ngOnInit() {
    this.subscriptionService.$notifications.subscribe((notifications: any[]) => {

      this.messages = notifications;
      if(notifications.length > 0) {

        //If there are messages, show them
        this.notificationOpen = true;
      };
    });

    this.subscriptionService.$notificationsCenter.subscribe((notifications: any[]) => {
      this.messagesCenter = notifications;
    });

    this.subscriptionService.$openNotifications.subscribe(() => {
      this.notificationOpen = true;
    });

    this.subscriptionService.$closeNotifications.subscribe(() => {
      this.notificationOpen = false;
    });
  }

  resetNotification() {
    this.notificationOpen = false;
    this.subscriptionService.$notifications.next([]);
  }

  switchNotification(event) {

    // 1. Mark the current notification as read
    let temp = this.subscriptionService.$notifications.value;

    temp[this.selectedNotification - 1]['read'] = true;
    this.subscriptionService.$notifications.next(temp);
    this.subscriptionService.$notificationsCenter.next(temp);

    this.selectedNotification = event.target.currentPage;

  }

  markAsRead(message) {
    // 1. Mark the current notification as read
    let temp = this.subscriptionService.$notificationsCenter.value;

    let index = temp.findIndex(notification => notification.id === message);
    if (index !== -1) {
      temp[index]['read'] = true;
      this.subscriptionService.$notificationsCenter.next(temp);
    }

    // 2. Close the notification
    this.notificationOpen = false;
  }


}
